import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Fragment } from 'react';
import styled from 'styled-components';
import ResourcesCardDefinition from './ResourceCard.js';
import { darkgrey, white } from '../../assets/colors.js';
import Theme from '../../Theme/index.js';

var _templateObject, _templateObject2;
var ResourceFrame = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  background-color: ", ";\n  box-shadow: ", ";\n  margin-bottom: 20px;\n\n  @media (min-width: 1199px) {\n    flex-basis: 66%;\n  }\n  @media (max-width: 768px) {\n    height: 100%;\n  }\n"])), function (props) {
  return props.color;
}, function (_ref) {
  var plain = _ref.plain;
  return plain ? "none" : "0 5px 10px 0 ".concat(Theme.colors.primaryShadow);
});
var FlexCard = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: space-between;\n  padding: 30px 0;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n\n  @media (min-width: 768px) {\n    & div.resource-card + div {\n      ", "\n    }\n  }\n"])), function (_ref2) {
  var vertical = _ref2.vertical;
  return vertical ? "column" : "row";
}, function (_ref3) {
  var separator = _ref3.separator;
  return separator && "border-left: 2px solid ".concat(darkgrey, ";");
});
var index = (function (_ref4) {
  var vertical = _ref4.vertical,
    separator = _ref4.separator,
    resources = _ref4.resources,
    plain = _ref4.plain;
  return /*#__PURE__*/React__default.createElement(ResourceFrame, {
    color: white,
    plain: plain
  }, /*#__PURE__*/React__default.createElement(FlexCard, {
    separator: separator,
    vertical: vertical
  }, resources.map(function (resource) {
    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: resource.id
    }, /*#__PURE__*/React__default.createElement(ResourcesCardDefinition, {
      resource: resource,
      vertical: vertical
    }));
  })));
});

export { FlexCard, ResourceFrame, index as default };
